export default "__VITE_ASSET__1W0$FXSG__"